<template>
  <div class="container tx-mediathek-detailoffers" :title="offer.hotelname">
    <div class="tx-mediathek-detailoffer">
      <div class="offer-image">
        <img :src="image.filename"
             :alt="offer.hotelname"
             :title="offer.hotelname"
             width="430"
             height="300"
             loading="lazy"/>

        <order-number :ordernumber="offer.orderNumber"
                      :bookablefrom="offer.bookableFrom"
                      :bookableto="offer.bookableTo"></order-number>

      </div>

      <div class="offer-description">
        <div class="offer-content">
          <div class="title">
            <h3 class="line-clamp" v-html="nameAndCategroy"></h3>
          </div>
          <p class="location"><i class="fa fa-map-marker"></i> {{ offer.destination }}</p>
          <p>
            <span v-if="offer.hasFlight" class="icon-plane"><i
                class="fa fa-plane"></i> inkl. Flug&nbsp;</span>
            <i class="fa fa-calendar"></i> {{ offer.duration }}
          </p>
          <div v-if="offer.advantages" class="offer-text" v-html="advantages"></div>
          <div class="overlay"></div>
        </div>
        <div class="offer-price">

          <rating v-if="offer.rating.count" v-bind:rating="offer.rating"></rating>

          <div class="offer-buttons">

            <price v-bind:price="offer.price"></price>

            <a class="btn btn-success pointer text-white"
               onclick="SK.tracking.DomEvent(this);"
               :data-uri="offer.urlDetail"
               data-event="CTAClick"
               :data-detail="tracking"
               target="_blank">
              JETZT ANSEHEN
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Price from "../Teaser/Price.vue";
import Rating from "../Teaser/Rating.vue";
import OrderNumber from "../Teaser/OrderNumber.vue";

export default {
  name: 'TvProgramOffer',
  data: () => {
    return {}
  },
  computed: {
    offer() {
      return this.$attrs.offer;
    },
    image() {
      return this.offer.images[0];
    },
    tracking() {
      return JSON.stringify(this.offer.tracking);
    },
    nameAndCategroy() {
      return `${this.offer.hotelname} ${this.offer.renderedCategory}`;
    },
    advantages() {
      return `<h4>Ihre besonderen sonnenklar.TV Vorteile</h4> ${this.offer.advantages}`;
    }
  },
  components: {
    OrderNumber,
    Price,
    Rating
  },
  created() {
  },
  mounted() {
  },
  methods: {}
}
</script>

<style lang="scss">
</style>